import { graphql, useStaticQuery } from 'gatsby';

import { QueryResponseAllCrewJson } from '../interfaces/QueryResponseAllCrewJson';

export const allCrewJson = (): QueryResponseAllCrewJson => {
  return useStaticQuery(graphql`
    query {
      allCrewJson {
        nodes {
          crew {
            name
            image
            description
            position
          }
          parent {
            ... on File {
              name
            }
          }
        }
      }
    }
  `);
};
